import React from 'react';
import './index.css';

export default class Home extends React.Component {
    constructor() {
        super();
        this.state = {
            step:1, //2,非强制,1 ，强制
        };
    }

    componentDidMount() {
    }

    render() {
        let {step,hideBox,imgUrl} = this.props
        return (
            <div className='follow'>
                <div className='follow_top'>
                    <span className='follow_top_title'>关注继续阅读完整版</span>
                    <img className='follow_top_erCode' src={imgUrl} alt=""/>
                    <span className='follow_top_tap'>长按三秒识别二维码关注</span>
                </div>
                <div className='follow_bot'>
                    <span className='follow_bot_single'>关注后分享有：</span>
                    <span className='follow_bot_single'>1.保存你的阅读记录，第一时间了解更新动态;</span>
                    <span className='follow_bot_single'>2.可参与小说情节走向，有机会与作者互动；</span>
                    <span className='follow_bot_single'> 3.更多无删减版好书等你看。</span>
                </div>
                {step == 2 && <a className='follow_go' onClick={()=>hideBox()}>跳过继续阅读</a>}
            </div>
        );
    }
}